import { Command_0_0_2 } from '@flexus/core';

export const SP_VIEW_JOB_CARD_PDF: Command_0_0_2 = {
	id: 'ViewJobCardPDF',
	itemType: 'command',
	includeForOnlyStates: ['all'],
	name: 'View / Print Job Card PDF',
	command: 'viewPDF'
};
